import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { GradingLockStatus } from "../../types/grading/PendingCorrection";
import { AxiosError } from "axios";

export const useGetGradingLockStatus = (examInstanceId: string, options?: { enabled?: boolean, refetchInterval?: number }) => {
  const axios = useAxios();

  return useQuery<GradingLockStatus>({
    queryKey: ["gradingLockStatus", examInstanceId],
    queryFn: async () => {
      const response = await axios.get<GradingLockStatus>(
        `/api/grading/examinstances/${examInstanceId}/lock-status`
      );
      return response.data;
    },
    enabled: !!examInstanceId && options?.enabled !== false,
    retry: (failureCount, error) => {
      const status = (error as AxiosError)?.response?.status;
      if (status === 403) {
        return false;
      }
      return failureCount < 2;
    },
    refetchInterval: (query) => {
      const status = (query?.state?.error as AxiosError | null)?.response?.status;
      if (status === 403) {
        return false;
      }
      return options?.refetchInterval || 30000; // Check lock status every 30s
    },
  });
};

export default useGetGradingLockStatus;
